<template>
  <div>
    <div v-if="!propLote"
         v-b-tooltip.hover.left="verifyDisable() ? getTextTooltip() : ''"
         class="p-0 m-0 text-center">
      <button
        id="btn-carga"
        :disabled="verifyDisable()"
        class="btn btn-outline-primary btn-block btn-sm"
        @click="verifyPermission()">
        Enviar para CRC
      </button>
      <b-tooltip v-if="propDataCarga"
                 target="btn-carga"
                 class="data-carga">
        {{ propDataCarga }}
      </b-tooltip>
    </div>

    <b-modal ref="modalCertificados"
             hide-footer
             title="Selecione um certificado"
             size="lg">
      <grid-certificados v-if="certificados && certificados.length > 0"
                         :certificados="certificados"
                         @onSelectCertificado="(cert) => propLote ? cargaLote(cert) : cargaUnica(cert)" />
    </b-modal>
  </div>
</template>
<script>
  /* helpers */
  import CargaSignature from '@/signature/CargaSignature'

  /* services */
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"

  /* constants */
  import erros from '@/constants/errosCarga'
  import { RESUMO_REGISTRO_ENVIAR_CARGA, ADMIN } from "@/constants/permissions"

  /* helpers */
  import ErrorsCasamentoHelper from "@/helpers/Errors/ErrorsCasamentoHelper"
  import ErrorsNascimentoHelper from "@/helpers/Errors/ErrorsNascimentoHelper"
  import ErrorsObitoHelper from "@/helpers/Errors/ErrorsObitoHelper"

  /* components */
  import GridCertificados from '../../GridCertificados'

  /* others */
  import {mapGetters} from "vuex"
  import moment from "moment"
  import momentTz from "moment-timezone"

  export default {
    name: 'Carga',
    components: {
      GridCertificados
    },
    props: {
      propTipoRegistro: { type: String, default: null },
      propRegistro: { type: Object, default: null },
      propDataCarga: { type: String, default: null},
      propLote: { type: Boolean, default: false },
      propObitoId: { type: [Number, String], default: null },
      propRegistros: { type: Array, default: () => ([])},
      propResultados: { type: Array, default: () => ([])}
    },
    data () {
      return {
        assinadorCarga: null,
        carga: false,
        certificados: [],
        data_ocorrido_para_envio_carga_casamento: null,
        RESUMO_REGISTRO_ENVIAR_CARGA,
        ADMIN
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      async handleCarga () {
        /**
         * Vericamos se o tipo de carga não é em lote
         * e caso não for verificamos se o registro possui O.S
         * ou ja foi feita a carga
         */
        if (this.propLote) {
          if (!this.propRegistros.length) return this.displayError('', 'Nenhum registro selecionado.')
        } else {
          if ( await this.verifySync() ) return
        }

        // Instanciamos a classe de forma global para não perder a referência
        this.assinadorCarga = new CargaSignature()

        // Obtendo os certificaos
        const certificado = await this.assinadorCarga.obterCertificados()

        /**
         * Caso o usuário tenha mais de um certificado abriremos o modal
         * para ele escolher o certificado que deseja usar
         *
         * Caso seja apenas um certificados verificaremos se a carga é em lote
         * ou individual e chamamos suas respectivas funções
         */
        if (Array.isArray(certificado)) {
          this.certificados = certificado

          this.$refs.modalCertificados.show()
        } else if (certificado) {
          if (this.propLote) this.cargaLote(certificado)
          else this.cargaUnica(certificado)
        }
      },
      verifyPermission () {
        /**
         * Verificamos diretamente no metodo por que a rota da carga é usada
         * no gerenciador de tarefas e no resumo de registro
         */
        // Se for oficial ou suporte não validamos
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [this.RESUMO_REGISTRO_ENVIAR_CARGA, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para realizar essa ação.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para realizar essa ação.')
        }

        this.handleCarga()
      },
      async cargaUnica (certificado) {
        try {
          loader({ text: "Enviando carga...", active: true })
          this.$refs.modalCertificados.hide()
          // Passamos o certificado selecionado para a classe de assinatura
          this.assinadorCarga.onSelectCertificado(certificado)

          // Iniciamos a assinatura passando o id do registro
          const res = await this.assinadorCarga.carga(this.propRegistro.registro_id)

          // Se não tiver erros retornamos uma mensagem de sucesso e recarregamos o registro
          if (!res.errors || !res.errors.length) {
            this.displaySuccess('', 'Carga enviada com sucesso').then(() => {
              this.$emit('reload', true)

              this.carga = true
            })
          } else {
            // Procuramos um erro que tenha mensagem (array ou string)
            const errors = res.errors.find(error => error.message)

            if (errors) {
              // Verificamos se a mensagem é um array ou uma string
              if (Array.isArray(errors.message)) {
                // exibimos o erro em forma de lista
                return this.displayListErrors('Erro ao enviar a carga!', errors.message)
              } else {
                // tratamos o erro para tranforma-lo em um array e exibi-lo em forma de lista
                this.tratarErros(errors.message)
              }
            } else {
              // Caso não tenha mensagem de erro retornamos uma mensagem genérica
              return this.displayListErrors('Erro ao enviar a carga!', 'Houve algum erro ao realizar a carga, favor contactar o suporte.')
            }
          }
        } catch (error) {
          // Usamos esse metodo para verificar o tipo de erro e retornar de forma adequada
          this.filterErros(error)
        } finally {
          loader({ text: "", active: false })
        }
      },
      async cargaLote (certificado) {
        // caso nenhum registro esteja selecionado, impedimos a assinatura de iniciar
        if (!this.propRegistros.length) this.displayError('', 'Nenhum registro selecionado.')

        try {
          loader({ text: "Enviando carga...", active: true })
          this.$refs.modalCertificados.hide()
          // Passamos o certificado selecionado para a classe de assinatura
          this.assinadorCarga.onSelectCertificado(certificado)
          // Enviamos todos os registros iniciados para a carga em lote
          const res = await this.assinadorCarga.carga(this.propRegistros)

          // Se não tiver erros retornamos uma mensagem de sucesso e recarregamos as tarefas
          if (!res.errors || !res.errors.length) {
            // Retornamos a mensagem de sucesso gerada pelo back
            await this.displaySuccess(res.end.message)
          } else {
            // Tratamos o erro para exibi-los em uma lista com suas respectivas tarefas
            const erro = {
              status: true,
              text: res.end.message,
              tasks: Array.isArray(res.errors) ? res.errors : [res.errors]
            }

            this.$emit('showErrors', erro)
          }

          //Atualizamos as tarefas
          this.$emit('reload', true)
        } catch (error) {
          // Usamos essa função para verificar o tipo de erro e retornar de forma adequada
          this.filterErros(error)
        } finally {
          loader({ text: "", active: false })
        }
      },
      filterErros (error) {
        const { response } = error

        if (response) {
          const { data } = response

          if (data) {
            const {message, errors} = data

            if (message) {
              if (message.message) {
                // Verificamos se o erro é de validação de xds se não for tratamos
                if (message.message.match('com o XSD')) {
                  return this.displayError('Erro ao enviar a carga', 'Erro de validação com o XSD.')
                } else {
                  return this.tratarErros(message.message)
                }
              } else if (Array.isArray(message)) {
                // Verificamos se a mensagem já vem como array e apenas a exibimos em lista
                return this.displayListErrors('Erro ao enviar a carga!', message)
              } else if (message.match(/.*504 Gateway Time-out.*/)) {
                // Verificamos se o erro é de time-out
                return this.displayError('Erro ao enviar a carga!', '504 Gateway Time-out')
              } else {
                // Caso não entre em nenhum exibimos a mensagem diretamente
                return this.displayError('Erro ao enviar a carga!', message)
              }
            } else if (errors) {
              // Verificamos se o erro tem items
              if (Array.isArray(errors) && errors.length) {
                // verificamos se a carga foi em lote para exibir corremente a lista de erros
                if (this.propLote) {
                  if (errors) {
                    /**
                     * Se der erro na primeira parte da assinatura não virá
                     * mensagem do back então editamos uma com a quantidade de
                     * erros retornados e enviamos para a exibição
                     */
                    const erro = {
                      status: true,
                      text: data.message ? data.message : `0 cargas realizadas com sucesso e ${errors.length} cargas com erro.`,
                      tasks: Array.isArray(errors) ? errors : [errors]
                    }

                    return this.$emit('showErrors', erro)
                  }
                } else {
                  /**
                   * Se não for carga em lote exibimos apenas o primeiro item
                   * e verificamos se esse item é um array para poder trata-lo
                   */
                  if (errors[0].message && Array.isArray(errors[0].message)) {
                    return this.displayListErrors('Erro ao enviar a carga!', errors[0].message)
                  } else if (errors[0].message) {
                    return this.displayError('Erro ao enviar a carga!', errors[0].message)
                  }
                  return this.displayError('Erro ao enviar a carga!', 'Houve algum erro ao realizar a carga, favor contactar o suporte.')
                }
              } else {
                /**
                 * Caso não tem nenhum erro exibimos uma mensagem generica pois
                 * não teremos como saber qual erro aconteceu
                 */
                return this.displayError('Erro ao enviar a carga!', 'Houve algum erro ao realizar a carga, favor contactar o suporte.')
              }
            } else {
              // Se não tiver errors e nem message exibimos diretamente o data
              return this.displayError('Erro ao enviar a carga', JSON.stringify(data))
            }
          } else {
            // Se não tiver data exibimos diretamente a response
            return this.displayError('Erro ao enviar a carga', JSON.stringify(response))
          }
        } else {
          // Verificamos se o erro tem descrição e se não tiver exibimos o erro diretamente
          if (error.description) {
            return this.displayError('Erro ao enviar a carga!', error.description)
          }
          return this.displayError('Erro ao enviar a carga!', JSON.stringify(error))
        }
      },
      async verifyOS () {
        try {
          loader({ text: "Verificando ordens de serviço...", active: true })

          let os = []

          if (this.propTipoRegistro === 'N') {
            os = await OrdensServicoService.getOSByResgitroId(this.propRegistro.registro.registro_id)
          } else if (this.propTipoRegistro === 'O') {
            os = await OrdensServicoService.getOSByResgitroId(this.propRegistro.registro_id)
          } else {
            os = await OrdensServicoService.getOSByResgitroId(this.propRegistro.registro.registro_id)
          }

          if (!os.length) {
            return this.displayError('Erro!', 'Cadastre uma ordem de serviço para realizar a carga.')
          }
        }
        catch (error) {
          return this.displayError('Erro!', 'Ocorreu um erro ao verificar se o registro possui ordem de serviço.')
        }
        finally {
          loader({ text: "", active: false })
        }
      },
      verifySync () {
        if (this.propTipoRegistro === 'O') {
          if (this.propRegistro.sync_crc || this.carga) {
            return this.displayError('Erro!', 'Carga ja realizada')
          }
        } else {
          if (this.propRegistro.registro.sync_crc || this.carga) {
            return this.displayError('Erro!', 'Carga ja realizada')
          }
        }
      },
      umDiaDepoisDataOcorrido () {
        const casamento = ['C', 'CR'].includes(this.propTipoRegistro)

        if (casamento) {
          const hoje = momentTz.tz(momentTz.utc(momentTz()), 'America/Sao_Paulo').format('YYYY-MM-DD')
          const umDiaDepois = moment(this.propRegistro.registro.data_ocorrido).add(1, 'days').format('YYYY-MM-DD')

          this.data_ocorrido_para_envio_carga_casamento = moment(umDiaDepois).format('DD/MM/YYYY')

          if (momentTz(hoje).isBefore(umDiaDepois)) return true
        }

        return false
      },
      displaySuccess (title, text, html) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        return Swal.fire(objSwal.success).then((res) => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''

          return res
        })
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then((res) => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''

          return res
        })
      },
      displayListErrors (title, listErrors) {
        let keys = []
        let errosRegistro = {}

        /**
         * Pegamos as keys de acordo com o tipo de registro
         *
         * Essas keys são indicativos de campos que aparecem no formulario
         * EX: GENITOR, NATURALIDADE, ETC.
         */
        switch (this.propTipoRegistro) {
        case 'N':
          keys = Object.keys(erros.nascimento)
          errosRegistro = erros.nascimento
          break
        case 'O':
          keys = Object.keys(erros.obito)
          errosRegistro = erros.obito
          break
        case 'C':
        case 'CR':
          keys = Object.keys(erros.casamento)
          errosRegistro = erros.casamento
          break
        }

        const correcoes = {}

        /**
         * Percorremos essas keys juntamente com a lista de erros
         * para verificar se existe alguma palavra em algum erro da lista
         * que é igual a alguma das keys
         *
         * Se for igual retornaremos o objeto de correções com as keys encontras
         * e o valor será a aba correspondente ao erro
         */
        keys.forEach((key) => {
          listErrors.forEach(err => {
            err = err.toUpperCase()

            if (err.match("\\b" + key + "\\b")) {
              correcoes[key] = errosRegistro[key]
            }
          })
        })

        // Transformamos os erros em lista para exibi-los
        const text = `<ul>${listErrors.map(res => {
          return `<li>${res}</li>`
        })}</ul>`

        objSwal.question.title = title
        objSwal.question.html = text.replace(/\,/g,'')
        objSwal.question.confirmButtonText = 'Continuar'

        return Swal.fire(objSwal.question).then((resp) => {
          delete objSwal.question.html

          /**
           * Se o usuario desejar corrigir os erros irá diretamente para a tela
           * de edição do registro juntamente com as suas correções a serem feitas
           */
          if (resp.value) {
            switch (this.propTipoRegistro) {
            case 'N':
              this.$router.push({name: 'edicao_nascimento', params: { idNasc: this.propRegistro.nascimento_id, propCorrecoes: correcoes }})
              break
            case 'O':
              this.$router.push({name: 'editar_obito', params: { id: this.propObitoId, propCorrecoes: correcoes }})
              break
            case 'C':
            case 'CR':
              this.$router.push({name: 'editar_casamento', params: { id: this.propRegistro.casamento_id, propCorrecoes: correcoes, propCasamento: this.propRegistro }})
              break
            }
          }
        })
      },
      tratarErros (error) {
        // Verificamos se o erro é de validação de xds
        const message = error.message ? error.message.match('com o XSD') : error.match('com o XSD')

        if (message) {
          return this.displayError('Erro ao enviar a carga', 'Erro de validação com o XSD.')
        }

        let erros = []

        // Tratamos o erro de acordo com o tipo de registro
        switch (this.propTipoRegistro) {
        case 'N':
          erros = ErrorsNascimentoHelper.errosNascimento(error.message ? error.message : error)
          break
        case 'O':
          erros = ErrorsObitoHelper.errosObito(error.message ? error.message : error)
          break
        case 'C':
        case 'CR':
          erros = ErrorsCasamentoHelper.errosCasamento(erros.message ? erros.message : error)
          break
        }

        /**
         * Pegamos o primeiro item da lista como titulo e o removemos para
         * não aparecer novamente na lista
         */
        const title = erros[0]
        erros.shift()

        // Enviamos o titulo e o erros para a função que exibe em forma de lista
        return this.displayListErrors(title, erros)
      },
      verifyDisable () {
        if (this.propRegistro.registro) {
          return this.propRegistro.registro.cod_motivo_alt === 99
        } else {
          return this.propRegistro.cod_motivo_alt === 99
        }
      },
      getTextTooltip () {
        return 'O motivo de alteração impede o envio da carga. Cód. 99.'
      }
    },
  }
</script>
<style lang="scss">
   .data-carga{
    font-family: Roboto;
    font-size: 14px;
    font-weight: normal;
    color: #373a3c;
    margin: 0;
  }
</style>
